export default __webpack_public_path__ + "static/media/about-2.b2c2d2c6.jpg";